// extracted by mini-css-extract-plugin
export default {"wrapper":"style-module--wrapper--38a40","logo":"style-module--logo--51e86"};